import { render, staticRenderFns } from "./productProModel.vue?vue&type=template&id=09238fec&scoped=true"
import script from "./productProModel.vue?vue&type=script&lang=js"
export * from "./productProModel.vue?vue&type=script&lang=js"
import style0 from "./productProModel.vue?vue&type=style&index=0&id=09238fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09238fec",
  null
  
)

export default component.exports